<ng-container *ngComponentOutlet="component"></ng-container>
